import mock from '@/fake-db/mock.js'

const data = {
    dataPermohonan: {
        analyticsData: [
          {
            'type': 'Masuk',
            'counts': 23043,
            'color': 'primary'
          },
          {
            'type': 'Selesai',
            'counts': 23043,
            'color': 'success'
          },
          {
            'type': 'Verifikasi',
            'counts': 14658,
            'color': 'warning'
          },
          {
            'type': 'Ditolak',
            'counts': 4758,
            'color': 'danger'
          }
        ],
        series: [70,30, 52, 26] //persentase dari total
    },
    dataPermohonanPerbidang: {
      analyticsData: [
        {
          'type': 'Kesra',
          'counts': 500,
          'color': 'primary'
        },
        {
          'type': 'Pembangunan',
          'counts': 300,
          'color': 'success'
        },
        {
          'type': 'Ekonomi',
          'counts': 200,
          'color': 'warning'
        },
      ],
      series: [50,30,20] //persentase dari total
    },
    dataVerifikasiPerbidang: {
      analyticsData: [
        {
          'type': 'Kesra',
          'counts': 400,
          'color': 'primary'
        },
        {
          'type': 'Pembangunan',
          'counts': 200,
          'color': 'success'
        },
        {
          'type': 'Ekonomi',
          'counts': 100,
          'color': 'warning'
        },
      ],
      series: [40,35,25] //persentase dari total
    },
    dataPermohonanPerminggu: {
      analyticsData: {
        thisWeek: 86,
        lastWeek: 73
      },
      series: [
        {
          name: 'Minggu Ini',
          data: [45, 47, 44, 47, 45, 48, 46, 48]
        },
        {
          name: 'Minggu Lalu',
          data: [46, 48, 45, 46, 44, 46, 45, 47]
        }
      ]
    },
}

mock.onGet('/api/dashboard/grafik-permohonan').reply(() => {
    return [200, data.dataPermohonan]
})

mock.onGet('/api/dashboard/grafik-permohonan-perbidang').reply(() => {
  return [200, data.dataPermohonanPerbidang]
})

mock.onGet('/api/dashboard/grafik-verifikasi-perbidang').reply(() => {
  return [200, data.dataVerifikasiPerbidang]
})

mock.onGet('/api/dashboard/grafik-permohonan-perminggu').reply(() => {
  return [200, data.dataPermohonanPerminggu]
})